export default {"src":"/_next/static/media/hairscalpFavicon.bdd3b820.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};